"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimeAgo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _intlRelativeTimeFormat = require("../../helpers/utils/intl-relative-time-format");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
if (!("RelativeTimeFormat" in Intl)) {
  (0, _intlRelativeTimeFormat.polyfillIntlRtf)();
}
var StyledTime = _styledComponents.default.time.withConfig({
  displayName: "TimeAgo__StyledTime",
  componentId: "sc-mtzp-0"
})([""]);

// Export explicit TimeAgo that is not wrapped with styled()
var TimeAgo = function TimeAgo(_ref) {
  var dateTime = _ref.dateTime,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? "en-us" : _ref$language,
    className = _ref.className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "" : _ref$testId;
  var locale = language;
  var date = (0, _react.useMemo)(function () {
    return new Date(dateTime);
  }, [dateTime]);
  var relativeDate = (0, _react.useMemo)(function () {
    return dateToRelative(date, new Date(), locale);
  }, [date, locale]);
  return /*#__PURE__*/_react.default.createElement(StyledTime, {
    dateTime: date.toISOString(),
    className: className,
    "data-testid": testId
  }, relativeDate);
};
exports.TimeAgo = TimeAgo;
var dateToRelative = function dateToRelative(date, current, locale) {
  var rtf;
  try {
    rtf = new Intl.RelativeTimeFormat(locale ? locale : undefined, {
      localeMatcher: "lookup",
      numeric: "auto",
      style: "long"
    });
  } catch (err) {
    rtf = new Intl.RelativeTimeFormat("en-us", {
      localeMatcher: "lookup",
      numeric: "auto",
      style: "long"
    });
  }

  // in seconds
  var diff = (date.getTime() - current.getTime()) / 1000;
  var absDiff = Math.abs(diff);
  if (absDiff < 3600) return rtf.format(Math.round(diff / 60), "minutes");else if (absDiff < 3600 * 24) return rtf.format(Math.round(diff / 3600), "hours");else if (absDiff < 3600 * 24 * 10) return rtf.format(Math.round(diff / (3600 * 24)), "days");else if (absDiff < 3600 * 24 * 31) return rtf.format(Math.round(diff / (3600 * 24 * 7)), "weeks");else if (absDiff < 60 * 60 * 24 * 365) return rtf.format(Math.round(diff / (60 * 60 * 24 * 365 / 12)), "months");else return rtf.format(Math.round(diff / (60 * 60 * 24 * 365)), "years");
};
// Exporting without the styled wrapper allows storybook to pick up the props automatically
// But does not allow for easier themed styling
var _default = (0, _styledComponents.default)(TimeAgo).withConfig({
  displayName: "TimeAgo",
  componentId: "sc-mtzp-1"
})([""]);
exports.default = _default;